import { type, Entity, validatedResource, association, resource, repository } from 'aurelia-orm';
import { ValidationRules } from 'aurelia-validation';
//import { TagRepository } from 'data/service/tag-repository';
import { autoinject } from 'aurelia-framework';
import { validateCompare } from "../customRules/compareValidation";


@resource('tag')
//@repository(TagRepository)
@validatedResource()
export class Tag extends Entity {
	
	id: number;
	name = null;
	entityStatusId: number = 1;
	
	constructor() {
		super();

		ValidationRules
			.ensure('name').required()
			.on(Tag);
	}


}